<!-- 任务5 -->
<template>
    <div>
      <div class="course_Task5">
        <el-row style="border: 1px solid #D3D3D3;margin: 0 20px 20px 20px;padding: 0 20px 20px 20px;min-height: calc(100vh - 280px);">
          <template v-if="examType == 2">
            <p style="background-color: rgb(239, 242, 247);margin: 0 -20px;color: #2789E2;padding: 20px;">
              任务得分：10 分
            </p>
          </template>
          <p class="fontB"><i class="el-icon-document-remove icon_"></i>任务名称：</p>
          <p style="min-height: 21px;">{{taskInfo.taskTitle}}</p>
          <p class="fontB"><i class="el-icon-s-data icon_" style="color: #8a39c2;"></i>任务分值：</p>
          <p style="min-height: 21px;">{{taskInfo.taskScore}}分</p>
          <p class="fontB"><i class="el-icon-document-copy icon_"></i>考核任务：</p>
          <el-row class="aljj">
            <previewIndex v-if="!$isEmpty(taskInfo.assessmentContent)" :modelValue="taskInfo.assessmentContent"></previewIndex>
          </el-row>
          <p class="fontB"><i class="el-icon-edit-outline icon_" style="color: #2eb68e;"></i>考核题目：</p>
          <el-row>
            <el-col :span="12" style="margin-left: 10px;">
              <el-table
                border
                ref="table"
                :data="tableData"
                style="width: calc(100% - 20px);">
                <el-table-column prop="handsOnSimulationTasksAssessmentQuestion" header-align="center" align="center" label="考核题目" width="120px"></el-table-column>
                <el-table-column prop="handsOnSimulationTasksAssessmentScore" header-align="center" align="center" label="分值" width="120px"></el-table-column>
                <el-table-column prop="handsOnSimulationTasksAssessmentAnswer" header-align="center" align="center" label="考核答案"></el-table-column>
              </el-table>
              <!-- <el-row class="tc m10">
                <el-button type="primary">提 交</el-button>
              </el-row> -->
            </el-col>
          </el-row>
        </el-row>
      </div>
    </div>
</template>
<script>
import previewIndex from "@/components/editorMd/previewIndex";	//富文本editorMd
export default {
  name: 'Task5',
  components: {
    previewIndex
  },
  props: {
    examType: { //考试类型 1：考试 2：查看成绩
      type: String,
      default: function(){
        return 1;
      }
    },
    taskId: { //任务ID
      type: String,
      default: function(){
        return "";
      }
    },
  },
  data() {
    return {
      tableData: [],
      answer:{},
      taskInfo:{} //任务详情
    }
  },
  created() {
    this.getInfo();
  },
  mounted() {

  },
  methods: {
    getInfo(){ //获取详情
      this.$get("/api/teacherOpenCourseHandsOnSimulationTasks/getInfo.do",{taskId:this.taskId}).then((ret) =>{
        if(ret.code == 0){
          this.taskInfo = ret.data;
          this.tableData = ret.data.teacherOpenCourseHandsOnSimulationTasksAssessmentList;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    }
  }
};
</script>
<style  lang="less">
  .course_Task5{
    .icon_{
      color: #2789E2;margin-right: 10px;
    }
    .has-gutter{
      th{
        border-color:#E5E5E5;
        background-color: #EFF2F7;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Teacher/components/PracticalTraining/Task4.vue